import { ReactNode, createContext, useEffect, useState } from 'react';

import services from 'services';
import { PlatformConfig } from 'types';

export const PlatformContext = createContext<PlatformConfig | null>(null);

const PlatformProvider = ({ children }: { children: ReactNode }) => {
  const [platformConfig, setPlatformConfig] = useState(services.appFrame.platform.getPlatformConfig);
  useEffect(() => {
    return services.appFrame.platform.onPlatformChange((newPlatformConfig: PlatformConfig) => {
      setPlatformConfig(newPlatformConfig);
    });
  }, []);

  return <PlatformContext.Provider value={platformConfig}>{children}</PlatformContext.Provider>;
};

export default PlatformProvider;
